import eventBus from '@/components/libs/eventBus.js';

let websocketUrl;
websocketUrl = window.location.hostname == "localhost" ? 'ws://localhost:8443' : (window.location.protocol == "https:" ? 'wss://' : "ws://") + window.location.host;
let socket = {
	selfClose: false, //是否是自己关闭的
	webSocket: null,
	getWS: function() {
		if (window.location.hostname == "localhost") {
			return websocketUrl + '/ws?token=' + this.getToken();
		}
		return websocketUrl + '/ws?token=' + this.getToken();
	},
	getToken() {
		return sessionStorage.getItem('token');
	},
	initWebSocket() {
		var token = sessionStorage.getItem('token');
		if (!token) {
			return;
		}
		this.closeSocket();
		this.connectSocket();
	},
	connectSocket() {
		this.selfClose = false;
		this.webSocket = new WebSocket(socket.getWS());

		this.webSocket.onopen = () => {
			console.log("onopen")
			this.pingSocket();
			this.webSocket.onmessage = this.receiveMessage
		};

		this.webSocket.onerror = (error) => {
			console.log("onerror", error)
			//setTimeout(this.connectSocket(), 2000);
		};

		this.webSocket.onclose = (event) => {
			console.log("onclose")
			if (!this.selfClose) {
				setTimeout(this.connectSocket(), 2000);
			}
		};

	},
	receiveMessage(content) {
		console.log("receiveMessage", content.data)
		if (content.data == "0") {
			setTimeout(function() {
				socket.pingSocket();
			}, 50000)
		} else {
			if (content.data == "-1") {
				location.reload();
				return;
			} else {
				var data = JSON.parse(content.data)
				if (data.type == "1") {
					console.log('sendmessage','message:' + data.type)
					eventBus.$emit('message:' + data.type,data.data);
				}
			}
		}
	},
	pingSocket() {
		this.webSocket.send("1");
	},
	closeSocket() {
		this.selfClose = true;
		if (this.webSocket) {
			this.webSocket.close();
		}
	}
}

export default socket;


// WEBPACK FOOTER //
// ./src/common/socket.js